import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonRequestService } from './common-request.service';
import { TableColumn } from './common-table.service';
import { UserService } from './user.service';
import { LayerCategoryStandardSchema } from './field-mapping.service';
import { ModelMenuItemKey } from './main-data.service';

interface ButtonDisable {
	disabled: boolean;
	reason?: string;
}

@Injectable({
  providedIn: 'root'
})
export class A3iService {

	parseSubject: Subject<any> = new Subject();
	saveParseSubject: Subject<any> = new Subject();
	commitSubject: Subject<{
		state: 'start' | 'done' | 'fail'
	}> = new Subject();
	clearEditsSubject: Subject<any> = new Subject();

	parseDisableBS: BehaviorSubject<ButtonDisable> = new BehaviorSubject({
		disabled: true
	});
	saveParseDisableBS: BehaviorSubject<ButtonDisable> = new BehaviorSubject({
		disabled: true
	});
	commitDisableBS: BehaviorSubject<ButtonDisable> = new BehaviorSubject({
		disabled: true
	});

	selectedRecordA3iBS: BehaviorSubject<{
		record;
		source?: 'card' | 'table'
	}> = new BehaviorSubject({
		record: null
	});
	a3iEditColumnsBS: BehaviorSubject<{columns: TableColumn[]}> = new BehaviorSubject({
		columns: []
	});

	uniqueIdCol: string; // global id
	// = '_id'; // internal id col

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }
	async parseAddress(addresses: string[], stateCode?: string | null, parseOnly?: boolean) {
		const apiKey = this.userService.getA3iApiKey();
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'a3i/parseGeneral';
			const body: any = {
				addresses: JSON.stringify(addresses)
			};
			if (stateCode) {
				body.stateCode = stateCode
			}
			if (parseOnly) {
				body.parseOnly = true;
			}
			const httpOptions = {
				headers: {'Authorization': apiKey}
			};
			// const httpOptions = {
			// 	headers: new HttpHeaders({
			// 		Authorization: apiKey
			// 	})
			// }
			console.log('parse Address start to call');
			this.requestService.requestPost(url, body, (rsp: any) => {
				resolve(rsp);
				console.log(rsp);
			}, (err: any) => reject(err), null, httpOptions);
		});
	}
	updateA3iParseResult(layerId, a3iOutputWId: {output; ids;}[]) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/a3iParseResult';
			const body = {
				// userSubscriptionId: this.userService.getUserInfo().userSubId,
				layerId: layerId,
				a3iOutputWId: JSON.stringify(a3iOutputWId)
			};
			this.requestService.requestPut(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
	updateNenaPartsByA3i(layerId, ids: any[]) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/nenaPartsByA3i';
			const body = {
				userSubscriptionId: this.userService.getUserInfo().userSubId,
				layerId: layerId,
				ids: JSON.stringify(ids)
			};
			this.requestService.requestPut(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
	async getRclByRcl(layerId, rclGrdId, model?: ModelMenuItemKey) {
		return new Promise<string[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/rclByRcl';
			const params: any = {
				layerId: layerId,
				rclGrdId: rclGrdId
			};
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp: {data: any[]}) => {
				const ids = [];
				rsp.data.forEach(i => ids.push(i.grd_globalid));
				resolve(ids);
			}, err => reject(err));
		})
	}
	getLstStandardCols(standardSchema: LayerCategoryStandardSchema[]) {
		return standardSchema.filter(c => c.colName.toLowerCase().startsWith('lst_'));
	}
	getStStandardCols(standardSchema: LayerCategoryStandardSchema[]) {
		return standardSchema.filter(c => c.colName.toLowerCase().startsWith('st_'));
	}
	combinePartsToAddress(standardCols: {colName: string}[], prefix: string, rec) {
		const parts = [];
		standardCols.forEach(c => {
			const part = rec[`${prefix}_${c.colName.toLowerCase()}`];
			if (part) {
				parts.push(part.trim());
			}
		});
		const addr = parts.join(' ').trim();
		return addr;
	}

	getRecordId(rec) {
		return rec[this.uniqueIdCol];
	}
}
